var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { customElement, css, html, LitElement, property } from 'lit-element';
let LoadingSpinner = class LoadingSpinner extends LitElement {
    constructor() {
        super(...arguments);
        this.size = 'big';
    }
    static get styles() {
        return css `
            .spinner,
            .spinner:after {
                border-radius: 50%;
                position: fixed;
                top: calc(50% - 10em);
            }
            .spinner.big,
            .spinner.big:after {
                width: 10em;
                height: 10em;
            }
            .spinner.small,
            .spinner.small:after {
                width: 2em;
                height: 2em;
            }
            .spinner {
                margin: 60px auto;
                font-size: 10px;
                position: relative;
                text-indent: -9999em;
                -webkit-transform: translateZ(0);
                -ms-transform: translateZ(0);
                transform: translateZ(0);
                -webkit-animation: load8 1.1s infinite linear;
                animation: load8 1.1s infinite linear;
            }

            .spinner.big {
                border-top: 1.1em solid rgba(0, 0, 0, 0.2);
                border-right: 1.1em solid rgba(0, 0, 0, 0.2);
                border-bottom: 1.1em solid rgba(0, 0, 0, 0.2);
                border-left: 1.1em solid var(--color-primary);
            }

            .spinner.small {
                border-top: 0.6em solid rgba(0, 0, 0, 0.2);
                border-right: 0.6em solid rgba(0, 0, 0, 0.2);
                border-bottom: 0.6em solid rgba(0, 0, 0, 0.2);
                border-left: 0.6em solid var(--color-primary);
            }

            @-webkit-keyframes load8 {
                0% {
                    -webkit-transform: rotate(0deg);
                    transform: rotate(0deg);
                }
                100% {
                    -webkit-transform: rotate(360deg);
                    transform: rotate(360deg);
                }
            }
            @keyframes load8 {
                0% {
                    -webkit-transform: rotate(0deg);
                    transform: rotate(0deg);
                }
                100% {
                    -webkit-transform: rotate(360deg);
                    transform: rotate(360deg);
                }
            }
        `;
    }
    render() {
        return html ` <div class="spinner ${this.size}"></div> `;
    }
};
__decorate([
    property({ type: String })
], LoadingSpinner.prototype, "size", void 0);
LoadingSpinner = __decorate([
    customElement('loading-spinner')
], LoadingSpinner);
export default LoadingSpinner;
